import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Bootstrap,
  Auth,
  IUser,
  ICart,
  EMPTY_CART,
  Cart,
  Shop
} from '@sellox/sellox-sdk';
import { filter } from 'rxjs/operators';

import './app.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../theme';
import firebase from 'firebase/app';
import { environment } from '../environment';
import { SelloxCore } from '../sellox-core';


Bootstrap(environment, firebase);


export default function RootLayout(props) {

  const [state, setState] = useState({});

  useEffect(() => {
    window['Sellox'] = window['Sellox'] || new SelloxCore()

    document.addEventListener(
      'add-cart', e => window['Sellox'].cartDialog.notify(true))

    try {

    } catch (error) {
      console.log(error)
    }

    listenToAuth();
  }, [])

  const listenToAuth = () => {
    import('firebase/auth')
      .then(_ => import('firebase/firestore'))
      .then(async _ => {
        Auth.bootstrap();
        Cart.bootstrap();

        Shop.data = (await Shop.getShop(environment.shop.username)).docs[0]?.data();
      });
    Auth.user$
      .pipe(filter(user => user !== null) as any)
      .subscribe((user: IUser) => {
        setState({ ...state, user, cart: user?.cart || { ...EMPTY_CART } })
      });
  }



  return (
    <React.Fragment>
      <Helmet>
        {/* <meta charset="utf-8" /> */}
        <meta name="generator" content="PWA Starter Kit" />
        <meta
          name="viewport"
          content="width=device-width, minimum-scale=1, initial-scale=1, user-scalable=yes"
        />
        <meta name="p:domain_verify" content="adcddf57d82f72d7791e9b37dada10fb" />
        <title>Reminisebyro Cosmetics - Home</title>
        <meta
          name="description"
          content="Reminisce by Ro is all about women empowerment. Bringing the beauty in every individual. It might take that one Reminisce
  product to bring out the confidence..."
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Reminisce by Ro Cosmetics" />
        <meta property="og:description" content="" />

        <meta
          property="og:image"
          content="http://cdn.shopify.com/s/files/1/1385/7027/t/7/assets/slide_6_1024x1024.jpg?1050789499310414205"
        />
        <meta
          property="og:image:secure_url"
          content="https://cdn.shopify.com/s/files/1/1385/7027/t/7/assets/slide_6_1024x1024.jpg?1050789499310414205"
        />
        <meta property="og:url" content="https://reminiscebyro.com/" />
        <meta property="og:site_name" content="Reminisce by Ro Cosmetics " />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@reminiscebyro" />
        <meta name="twitter:title" content="Reminisce by Ro Cosmetics" />
        <meta name="twitter:description" content="" />
        <meta
          name="twitter:image"
          content="https://cdn.shopify.com/s/files/1/1385/7027/t/7/assets/slide_1_1024x1024.jpg?1050789499310414205"
        />
      </Helmet>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </React.Fragment>
  );
}
